import React from 'react';
import { Box, BoxProps } from '@mui/material';

const Image = ({ ...props }: BoxProps<'img'>) => {
  return <Box component="img" {...props} />;
};
export default Image;
